<template>
  <div>
    <header>
      <div class="container">
        <div class="left-panel">
          <a><i><icon name="file-text-o" scale="2"/></i></a>
          <router-link :to="{name: 'Home'}"><i><icon name="home" scale="2"/></i></router-link>
        </div>
        <div class="right-panel">
          <a class="primary"><i>Submit Paper</i></a>
          <a class="secondary"><i><icon name="search" scale="2"/></i></a>
          <a class="secondary"><i><icon name="arrow-circle-up" scale="2"/></i></a>
        </div>
      </div>
      <div id="swichPanel" class="switch-panel"><a @click="switchToTraditional()">< Switch to Traditional Reading Experience</a></div>
    </header>
    <div v-if="prevPage" class="nav-btn btn-top" @click="navigateTop()">
      <icon name="caret-up" scale="2"/>
    </div>
    <div v-if="nextPage" class="nav-btn btn-bottom" @click="navigateBottom()">
      <icon name="caret-down" scale="2"/>
    </div>
    <div v-if="prevSlide" :class="{ 'nav-btn': true, 'btn-left': true, 'has-nav-top': prevPage, 'has-nav-bottom': nextPage }" @click="navigateLeft()">
      <icon name="caret-left" scale="2"/>
    </div>
    <div v-if="nextSlide" :class="{ 'nav-btn': true, 'btn-right': true, 'has-nav-top': prevPage, 'has-nav-bottom': nextPage }" @click="navigateRight()">
      <icon name="caret-right" scale="2"/>
    </div>
    <div id="enhanced-container" :class="{ 'enhanced-container': true, 'has-nav-top': prevPage, 'has-nav-bottom': nextPage }"
         v-touch:swipe="swipeHandler">
      <transition name="page" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>


<script>
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'

  let swichPanel = document.getElementById('swichPanel')
  let scrollPosition = swichPanel ? swichPanel.offsetTop : 0

  export default {
    name: 'enhansed-view',
    mixins: [ UtilityMixin ],
    data () {
      return {
        prevPage: false,
        nextPage: false,
        prevSlide: false,
        nextSlide: false,
        scrolled: false
      }
    },
    created () {
    },
    mounted () {
      this.toggleHeader()
      window.addEventListener('scroll', this.toggleHeader)
    },
    destroyed () {
      window.removeEventListener('scroll', this.toggleHeader)
    },
    methods: {
      switchToTraditional () {
        this.$store.commit('setMode', false)
        if (this.$route.name === 'article-interact') {
          this.$router.push({name: 'article-data', params: this.$route.params})
        } else if (this.$route.name === 'article-interact-tables') {
          this.$router.push({name: 'article-data', params: this.$route.params, hash: '#Tables'})
        } else if (this.$route.name === 'article-interact-figures') {
          this.$router.push({name: 'article-data', params: this.$route.params, hash: '#Figures'})
        } else if (this.$route.name === 'article-interact-video') {
          this.$router.push({name: 'article-data', params: this.$route.params, hash: '#Video'})
        } else if (this.$route.name === 'article-interact-trivia') {
          this.$router.push({name: 'article-data', params: this.$route.params})
        } else if (this.$route.name === 'article-metrics-geographics' || this.$route.name === 'article-metrics-demographics') {
          this.$router.push({name: 'article-detail', params: this.$route.params})
        } else if (this.$route.name.match(/^article-media/)) {
          this.$router.push({name: 'article-detail', params: this.$route.params})
        }
      },
      toggleHeader () {
        this.scrolled = window.scrollY > scrollPosition
        !this.prevPage && !this.prevSlide && !this.scrolled ? this.$parent.$el.classList.add('has-header') : this.$parent.$el.classList.remove('has-header')
      },
      swipeHandler (direction) {
        switch (direction) {
          case 'bottom' :
            if (!this.scrolled) {
              this.navigateTop()
            }
            break
          case 'top' :
            if ((document.documentElement.scrollHeight - window.pageYOffset) <= document.documentElement.clientHeight || document.documentElement.scrollHeight < document.documentElement.clientHeight) {
              this.navigateBottom()
            }
            break
          case 'right' :
            this.navigateLeft()
            break
          case 'left' :
            this.navigateRight()
            break
        }
      },
      navigateTop () {
        this.$el.classList.remove('transition-bottom', 'transition-left', 'transition-right')
        this.$el.classList.add('transition-top')
        this.$router.push(this.prevPage)
        setTimeout(this.toggleHeader.bind(this), 500)
      },
      navigateBottom () {
        this.$el.classList.remove('transition-top', 'transition-left', 'transition-right')
        this.$el.classList.add('transition-bottom')
        this.$router.push(this.nextPage)
        setTimeout(this.toggleHeader.bind(this), 500)
      },
      navigateLeft () {
        this.$el.classList.remove('transition-top', 'transition-bottom', 'transition-right')
        this.$el.classList.add('transition-left')
        this.$router.push(this.prevSlide)
        setTimeout(this.toggleHeader.bind(this), 500)
      },
      navigateRight () {
        this.$el.classList.remove('transition-top', 'transition-bottom', 'transition-left')
        this.$el.classList.add('transition-right')
        this.$router.push(this.nextSlide)
        setTimeout(this.toggleHeader.bind(this), 500)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-enter-active {
    transition: opacity .3s, transform .3s;
  }
  .page-leave-active {
    transition: opacity .5s, transform .3s;
  }
  .page-enter, .page-leave-to {
    opacity: 0;
  }
  .transition-right .page-enter {
    transform: translateX(100%);
  }
  .transition-right .page-leave-to {
    transform: translateX(-100%);
  }
  .transition-left .page-enter {
    transform: translateX(-100%);
  }
  .transition-left .page-leave-to {
    transform: translateX(100%);
  }
  .transition-top .page-enter {
    transform: translateY(-100%);
  }
  .transition-top .page-leave-to {
    transform: translateY(100%);
  }
  .transition-bottom .page-enter {
    transform: translateY(100%);
  }
  .transition-bottom .page-leave-to {
    transform: translateY(-100%);
  }

  header .container {
    min-height: 0px;
    visibility: hidden;
    padding: 0px;
    border-top: 0;

    background-color: $light-grey-color;
    background-repeat: no-repeat;
    background-position: top left;
    width: 100%;
    margin: 0;
    a {
      height: 48px;
      border: 1px solid $grey-font;
      display: inline-block;
      padding: 5px 10px;
      line-height: 34px;
      vertical-align: middle;
      cursor: pointer;
    }
    a.primary {
      background-color: $primary-color;
      color: $white;
      padding: 5px 20px;
    }
    a.secondary {
      background-color: $secondary-color;
      color: $white;
    }
  }

  .has-header header .container {
    border-top: 3px solid $primary-color;
    padding: 10px 40px;
    min-height: 80px;
    width: 100% !important;
    visibility: visible;
    transition: all 0.2s;
    .left-panel, .right-panel {
      display: inline-block;
    }
  }

  header .switch-panel {
    position: fixed;
    z-index: 1;
    top: 0;
    background-color: $white;
    padding: 10px 40px;
    border-width: 1px 0;
    border-style: solid;
    border-color: $grey-border;
    color: $primary-color;
    font-family: 'Merriweather', serif;
    font-style: italic;
    font-size: 16px;
    width: 100%;
    margin: 0;
    a {
      cursor: pointer;
    }

  }

  .has-header header .switch-panel {
    position: static;
  }

  .nav-btn.btn-top, .nav-btn.btn-bottom {
    color:  $secondary-color;
    height: 36px;
    &:hover {
      background-color: $secondary-color;
      border-color: transparent;
      color: $white;
    }
    background-color: $white;
    width: 100%;
    position: fixed;
    z-index: 1;
    >* {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .nav-btn.btn-bottom {
    bottom: 0;
  }
  .nav-btn.btn-top {
    border-bottom: 1px solid #dedede;
  }
  .nav-btn.btn-bottom {
    border-top: 1px solid #dedede;
  }

  .nav-btn{
    text-align: center;
    color: $primary-color;
    cursor: pointer;
    &:before {
      content: '';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
    }
    &.btn-right, &.btn-left {
      width: 36px;
      &:hover {
         background-color: $primary-color;
         border-color: transparent;
         color: $white;
      }
      background-color: $white;
      position: fixed;
      bottom: 6px;
      &.has-nav-top {
        margin-top: 46px;
      }
      &.has-nav-bottom {
        margin-bottom: 36px;
      }
    }
    &.btn-right {
      right: 0;
      border-left: 1px solid #dedede;
    }
    &.btn-left {
      left: 0;
      border-right: 1px solid #dedede;
    }
  }

  .enhanced-container {
    background-color: $white;
    overflow-y: auto;
    overflow-x: hidden;
    position: static;
    min-height: calc(100vh - 80px);
    bottom: 6px;
    left: 40px;
    right: 40px;
    margin-top: 46px;
    padding: 10px 60px;
    &.has-nav-top {
      margin-top: 46px;
      >div {
        margin-top: 40px;
      }
    }
    &.has-nav-bottom {
      margin-bottom: 36px;
    }
  }

  .right-panel {
    display: none;
    float: right;
  }
  .left-panel {
    display: none;
    float: left;
    color: $primary-color;
  }

  .btn-right, .btn-left, .enhanced-container {
    top: 50px;
    transition: top 0.2s;
  }
  .has-header {
    .btn-right, .btn-left {
      top: 130px;
      transition: top 0.2s;
    }
    .enhanced-container {
      margin-top: 0px;
    }
  }

</style>



// WEBPACK FOOTER //
// EnhancedViewComponent.vue?50601ff3